import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_ROUTES, RoleEnum } from '@core/constants';
import { Global } from '@core/services';

export const roleGuard = (allowedRoles: readonly RoleEnum[] = []): CanActivateFn => {
  return () => {
    const global = inject(Global);
    const router = inject(Router);

    const userRoles = (global.rol() || []).map((r) =>
      r.trim().toUpperCase(),
    ) as RoleEnum[];

    if (!userRoles || userRoles.length === 0) {
      router.navigate([APP_ROUTES.LOGIN]);
      return false;
    }

    if (allowedRoles.length === 0) {
      router.navigate([APP_ROUTES.LOGIN]);
      return false;
    }

    const hasAccess = userRoles.some((role) => allowedRoles.includes(role));

    if (!hasAccess) {
      switch (userRoles[0]) {
        case RoleEnum.RECEPTIONIST:
          router.navigate([APP_ROUTES.HOME_RECEPTION]);
          return false;
        case RoleEnum.TECHNICIAN:
          router.navigate([APP_ROUTES.HOME_TECHNICAL]);
          return false;
        case RoleEnum.ADMIN:
          router.navigate([APP_ROUTES.HOME_ADMIN]);
          return false;
      }
      router.navigate([APP_ROUTES.LOGIN]);
      return false;
    }

    return true;
  };
};
